import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue} from 'redux-form';
import excluirUsuariosEmpresaAgencia from '../../../actions/usuario-empresa-agencia/excluirUsuariosEmpresaAgencia';
import buscarUsuariosEmpresaAgencia from '../../../actions/usuario-empresa-agencia/buscarUsuariosEmpresaAgencia';

export class UsuarioEmpresaAgencia extends React.Component {
  excluir (id) {
    this.props.excluirUsuariosEmpresaAgencia(this.props.empresaSelecionada.id, id)
      .then(() => {
          this.props.buscarUsuario()
          this.props.buscarUsuariosEmpresaAgencia(this.props.empresaSelecionada.id, this.props.usuarioSelecionado.usuarioEmpresaId)
      })
  }

  render () {
    return (
      <div className="geral">
        <div className="resumo">
          <div className="row">
            <div className="col-lg-9 col-xl-9">
              <span className="titulo-mobile">Nome:&nbsp;</span>{this.props.usuarioEmpresaAgencia.nomeAgenciaComNumero}
            </div>
            <div className="col-lg-3 col-xl-3">
              <div className="acoes">
                <div className="botoes">
                  <button type="button" className="btn btn-excluir"
                          onClick={() => this.excluir(this.props.usuarioEmpresaAgencia.id)}>
                    <i className="material-icons nav-icon">&#xe872;</i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export function mapStateToProps (state) {
  return {
    usuarioSelecionado: state.usuarioSelecionado,
    empresaSelecionada: state.empresaSelecionada
  }
}

export default connect(mapStateToProps, {
  changeFieldValue,
  excluirUsuariosEmpresaAgencia,
  buscarUsuariosEmpresaAgencia
})(UsuarioEmpresaAgencia)
